<template>
<div>
    <el-card v-loading="loading.initial" shadow="never" :body-style="{ padding: '10px 20px' }" class="mb-4 mx-auto"  style="min-height: 100px">
        <el-tabs v-if="!loading.initial" v-model="activeTab" tab-position="top">
            <el-tab-pane label="Find media" name="download">
                <onlyfans-download-form v-if="platform == 'onlyfans'" ref="form" v-loading="loading.media" @download="submitForm" :extensionInfo="extensionInfo" :me="me"></onlyfans-download-form>
                <fansly-download-form v-else-if="platform == 'fansly'" ref="form" v-loading="loading.media" @download="submitForm" :extensionInfo="extensionInfo" :me="me"></fansly-download-form>
                <redgifs-download-form v-else-if="platform == 'redgifs'" ref="form" v-loading="loading.media" @download="submitForm" :extensionInfo="extensionInfo" :me="me"></redgifs-download-form>
                <ashemaletube-download-form v-else-if="platform == 'ashemaletube'" ref="form" v-loading="loading.media" @download="submitForm"></ashemaletube-download-form>
                <xhamster-download-form v-else-if="platform == 'xhamster'" ref="form" v-loading="loading.media" @download="submitForm"></xhamster-download-form>
                <bilibili-download-form v-else-if="platform == 'bilibili'" ref="form" v-loading="loading.media" @download="submitForm" :extensionInfo="extensionInfo"></bilibili-download-form>
                <shesfreaky-download-form v-else-if="platform == 'shesfreaky'" ref="form" v-loading="loading.media" @download="submitForm"></shesfreaky-download-form>
                <boyfriendtv-download-form v-else-if="platform == 'boyfriendtv'" ref="form" v-loading="loading.media" @download="submitForm"></boyfriendtv-download-form>
                <eporner-download-form v-else-if="platform == 'eporner'" ref="form" v-loading="loading.media" @download="submitForm"></eporner-download-form>
                <tnaflix-download-form v-else-if="platform == 'tnaflix'" ref="form" v-loading="loading.media" @download="submitForm"></tnaflix-download-form>
            </el-tab-pane>
            <el-tab-pane label="Results" name="results">
                <div class="mb-4 flex justify-between items-center">
                    <div class="flex gap-2">
                        <el-checkbox size="large" border v-model="options.hideShort" :label="true">Hide short videos</el-checkbox>
                        <el-radio-group size="large" v-model="options.mediaType">
                            <el-radio-button label="video">Video</el-radio-button>
                            <el-radio-button label="photo">Photo</el-radio-button>
                            <el-radio-button label="all">All</el-radio-button>
                        </el-radio-group>
                    </div>
                    <div>
                        <el-button :loading="flags.downloadingAll" size="large" :icon="ElIconDownload" @click="downloadAll()" title="Download all loaded videos on this page">Download All &mdash; {{filteredMedia.length}}</el-button>
                        <el-button :loading="flags.downloadingAll" size="large" :icon="ElIconDownload" @click="bulkDownload()" title="Download all videos matching these filters">Bulk Download</el-button>
                    </div>
                </div>
                <div v-if="hiddenCount > 0" class="text-sm mb-4 text-gray-500">
                    {{hiddenCount}} item{{hiddenCount > 1 ? 's are' : ' is'}} hidden
                </div>        
                <div class="mb-4">
                    <el-alert v-if="!localStorage.warningRead" title="Warning" type="warning" effect="light" show-icon closable @close="localStorage.warningRead = true">
                        By downloading the media files, you agree that you will only keep them for yourself and will not share them with anyone else.
                    </el-alert>
                </div>
                <div class="flex flex-wrap mb-4 gap-x-4 gap-y-8" v-if="filteredMedia.length > 0">
                    <el-card class="flex" style="width: 400px; border: none;" shadow="never" :body-style="{padding: '0', flexGrow: 1, display: 'flex'}"  v-for="media in filteredMedia" :key="media.id">
                        <media :media="media" :source="platform" :job="allJobs.find(job => job.id == media.id)"></media>
                    </el-card>
                </div>
                <div class="flex flex-col justify-center items-center gap-2 mb-1">
                    <div v-if="loading.media" class="flex gap-5">
                        Loading media...
                        <ElIconLoading width="20"></ElIconLoading>
                    </div>
                    <div v-else-if="media.length == 0">No downloadable media found</div>
                    <div v-else-if="!cursor" class="text-center">No more items to load</div>
                    <template v-else-if="!store.user.isPremium">
                        <p> Subscribe to premium plan to access more downloads - $10 / month  </p>
                        <google-signin v-if="!store.user._id" :width="200"></google-signin>
                        <div v-else style="width:200px">
                            <paypal-button></paypal-button>
                        </div>
                    </template>
                    <div v-else>
                        <el-button type="text" @click="handleScroll()" :icon="ElIconArrowDown">Load more</el-button>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </el-card>
    <el-dialog
        title="Download links"
        v-model="downloadLinks.show"
        width="40%"
        @close="downloadLinks.show = false">
        <el-alert type="info" :closable="false" show-icon title="You can only download these links from your current IP address"></el-alert>
        <div class="mb-4"></div>
        <div style="white-space: nowrap; word-break: none; max-height: 500px; overflow: auto">
            <div v-for="link in downloadLinks.links" :key="link"> {{link}} </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
const {
    useExtension, 
    getExtensionID, 
    generateFilePath, 
    parseUrl, 
    waitForExtensionConnection,
    download
} = useHelpers()
const onlyfans = useOnlyfans()
const fansly = useFansly()
const redgifs = useRedgifs()
const ashemaletube = useAshemaletube()
const xhamster = useXhamster()
const bilibili = useBilibili()
const shesfreaky = useShesfreaky()
const boyfriendtv = useBoyfriendtv()
const eporner = useEporner()
const tnaflix = useTnaflix()
const {formatDate} = useFilters()

export default {
    inject: ['jobs', 'hlsJobs', 'drmJobs', 'dashJobs', 'downloadJobs'],
    beforeCreate() {
        this.store = useStore()
    },
    data () {
		return {
            flags: {
                downloadingAll: false
            },
            localStorage,
			allItemsLoaded: false,
            showDemoVideo: false,
            downloadLinks: {
                show: false,
                links: []
            },
            options: {
				hideLocked: false,
                mediaType: 'all'
			},
			loading: {
				initial: true,
				media: false,
                cancel: false
			},
            urlInfo: {type: '', websiteName: '', chatId: '', username: '', postId: ''},
			activeTab: 'download',
			extensionInfo: { version: '' },
			me: { id: '', name: '', email: '', loading: true},
			form: {},
			items: [],
			media: [],
			cursor: undefined
		}
	},
    async beforeMount () {
        this.showDemoVideo = false
		let result = await waitForExtensionConnection()
        this.loading.initial = false
        Object.assign(this.extensionInfo, result)
        this.init()
	},
	destroyed () {
    	window.removeEventListener('scroll', this.handleScroll)
  	},
	methods: {
        formatDate,
        async cancelSubscription () {
            this.loading.cancel = true
            let response = await useApi('/user/me/subscription/cancel', {method: 'post'})
            if (response.success) {
                this.store.user.subscription.isActive = false
                ElNotification({
                    type: 'success',
                    title: 'Subscription canceled',
                    message: 'Your subscription has been canceled successfully.'
                })
            }
            this.loading.cancel = false
        },
        async pauseJob (job) {
            if (job.type == 'hls') {
                await useExtension('hlsDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'dash') {
                await useExtension('dashDownloadPool.pauseJob', [job.id], 'offscreen')
            } else if (job.type == 'download') {
                await useExtension('downloadPool.pauseJob', [job.id], 'sandbox')
            }
        },
        async resumeJob (job) {
            if (job.type == 'hls') {
                await useExtension('hlsDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'dash') {
                await useExtension('dashDownloadPool.resumeJob', [job.id], 'offscreen')
            } else if (job.type == 'download') {
                await useExtension('downloadPool.resumeJob', [job.id], 'sandbox')
            }
        },
        getLinks () {
            let links = this.media.map(item => item.full || item.files.full.url)
            this.downloadLinks.links = links
            this.downloadLinks.show = true
        },
		async init () {
            let [storageReq] = await Promise.all([
                useExtension('chrome.storage.local.get', [['options', 'data']])
            ])
            Object.assign(this.options, storageReq?.result?.options || {})
            this.loading.initial = false
            
			if (this.extensionInfo.version) {
				const service = this.platform == 'fansly' ? fansly : onlyfans
				this.me = await service.getMe()
                this.me.loading = false
			}
			window.addEventListener('scroll', this.handleScroll)
		},
		async bulkDownload () {
            if (!this.store.user.isPremium) {
                return ElNotification({
                    type: 'error',
                    title: 'Premium required',
                    message: 'You need to be a premium user to use this feature, scroll down to subscribe to premium plan.'
                })
            }
            this.flags.downloadingAll = true
            useExtension('taskManager.addTask', ['BulkDownload', this.form], 'sandbox')
            ElNotification({
                type: 'success',
                title: 'Task started',
                message: 'Bulk downloader task has been started!'
            })
            setTimeout(() => this.flags.downloadingAll = false, 10e3)
        },
		async downloadAll () {
            try {
                await ElMessageBox.confirm(
                    `Are you sure you want to download all ${this.filteredMedia.length} items?`,
                    'Confirm Download All',
                    {
                        confirmButtonText: 'Download All',
                        cancelButtonText: 'Cancel',
                        type: 'info',
                    }
                )
            } catch (error) {
                return
            }

            this.flags.downloadingAll = true
            const mediaToDownload = [...this.filteredMedia];
            for (let item of mediaToDownload) {
                // Fire and forget to avoid blocking UI
                // Pass false to suppress individual notifications
                download(item, this.platform, false)
                // Small delay to let Vue process updates between messages
                await new Promise(r => setTimeout(r, 20));
			}
            
            ElNotification({
                title: 'Bulk Download Started',
                message: `${mediaToDownload.length} downloads have been added to the queue.`,
                type: 'success'
            })

            // Final check to sync state
            setTimeout(() => {
                this.flags.downloadingAll = false
            }, 2000)
		},
		async handleScroll () {
			if (this.activeTab != 'results') return
			if (!this.store.user.isPremium) return
			const bottomOfWindow = document.documentElement.scrollHeight - window.innerHeight - 600;
			if (window.scrollY > bottomOfWindow && !this.loading.media && this.cursor) {
				let media = await this.fetchMedia()
				this.media = this.media.concat(media)
			}
		},


		validateForm (form) {
			return new Promise(resolve => form.validate(resolve))
		},
		async fetchMedia () {
			let media = []
			let {form} = this
			this.loading.media = true
            
            let result
            if (this.platform == 'ashemaletube') {
                result = await ashemaletube.getMedia(form)
            } else if (this.platform == 'xhamster') {
                result = await xhamster.getMedia(form)
            } else if (this.platform == 'bilibili') {
                result = await bilibili.getMedia(form)
            } else if (this.platform == 'shesfreaky') {
                result = await shesfreaky.getMedia(form)
            } else if (this.platform == 'boyfriendtv') {
                result = await boyfriendtv.getMedia(form)
                console.log('[Downloader] Boyfriendtv media found:', result);
            } else if (this.platform == 'eporner') {
                result = await eporner.getMedia(form)
            } else if (this.platform == 'tnaflix') {
                result = await tnaflix.getMedia(form)
            } else if (this.platform == 'onlyfans') {
                result = await onlyfans.getMedia({form, urlInfo: this.urlInfo, cursor: this.cursor})
            } else if (this.platform == 'fansly') {
                result = await fansly.getMedia({form, urlInfo: this.urlInfo, cursor: this.cursor})
            } else if (this.platform == 'redgifs') {
                result = await redgifs.getMedia({form, urlInfo: this.urlInfo, cursor: this.cursor})
            }

            if (Array.isArray(result)) {
                media = result
                this.cursor = ''
            } else if (result) {
                media = result.items
                this.cursor = result.cursor
            }
            
			this.activeTab = 'results'
			setTimeout(() => {
				this.loading.media = false
				this.handleScroll()
			}, 1000)
			return media
		},
		async submitForm (form) {
			let formRef = this.$refs.form?.$refs?.downloadForm || this.$refs.form?.$refs?.form?.$refs?.downloadForm
			let isValid = await this.validateForm(formRef)
			if (!isValid) return console.error('Form is not valid')
			this.cursor = ''
			this.form = form
			
			// Handle ashemaletube with multiple links
			if (this.platform == 'ashemaletube') {
				this.urlInfo = { websiteName: 'ashemaletube.com', type: 'video' }
			} else if (this.platform == 'xhamster') {
				this.urlInfo = { websiteName: 'xhamster.com', type: 'video' }
			} else if (this.platform == 'bilibili') {
				this.urlInfo = { websiteName: 'bilibili.com', type: 'video' }
			} else if (this.platform == 'shesfreaky') {
				this.urlInfo = { websiteName: 'shesfreaky.com', type: 'video' }
        } else if (this.platform == 'boyfriendtv') {
            this.urlInfo = { websiteName: 'boyfriendtv.com', type: 'video' }
        } else if (this.platform == 'eporner') {
            this.urlInfo = { websiteName: 'eporner.com', type: 'video' }
        } else if (this.platform == 'tnaflix') {
            this.urlInfo = { websiteName: 'tnaflix.com', type: 'video' }
        } else if (form.source != 'all') {
                this.urlInfo = parseUrl(this.form.url)
                if (!this.urlInfo) {
                    return ElNotification({
                        type: 'error',
                        title: 'URL not supported',
                        message: 'This URL is not recognized as a post, profile or chat URL'
                    })
                }
            } else {
                this.urlInfo.websiteName = this.platform == 'fansly' ? 'fansly.com' : 'onlyfans.com'
            }
            
            // For ashemaletube and shesfreaky, extension is optional (can download direct video URLs)
            if (this.platform != 'ashemaletube' && this.platform != 'shesfreaky') {
                if (!getExtensionID() || !this.extensionInfo.version) {
                    return ElNotification({
                        type: 'error',
                        title: 'Unable to connect to extension',
                        message: 'Make sure that the chrome extension is installed, enabled and upto date.'
                    })
                }
            }
            this.media = await this.fetchMedia(this.urlInfo)
		}
	},
    computed: {
        platform () {
            if (this.$route?.fullPath?.includes('fansly')) return 'fansly'
            if (this.$route?.fullPath?.includes('redgifs')) return 'redgifs'
            if (this.$route?.fullPath?.includes('ashemaletube')) return 'ashemaletube'
            if (this.$route?.fullPath?.includes('xhamster')) return 'xhamster'
            if (this.$route?.fullPath?.includes('bilibili')) return 'bilibili'
            if (this.$route?.fullPath?.includes('shesfreaky')) return 'shesfreaky'
            if (this.$route?.fullPath?.includes('boyfriendtv')) return 'boyfriendtv'
            if (this.$route?.fullPath?.includes('eporner')) return 'eporner'
            if (this.$route?.fullPath?.includes('tnaflix')) return 'tnaflix'
            return 'onlyfans'
        },
        allJobs () {
            return this.jobs ? this.jobs() : []
        },
        filteredMedia () {
            return this.media.filter(media => {
                if (!media) return 
                let {hideLocked, hideShort, shortVideoLength, mediaType} = this.options
                if (hideLocked && !media.canView) return false
                if (hideShort) {
                    if (media.type == 'video' && media.duration < shortVideoLength) return false
                }
                if (mediaType != 'all' && media.type != mediaType) return false
                return true
            })
        },
        hiddenCount () {
            return this.media.length - this.filteredMedia.length
        }
    }
}
</script>

<style>
	.el-popover {
		word-break: keep-all!important;
	}
	.el-checkbox {
		margin-right: 0;
	}
</style>